<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.usersEditedItem.NOM"
                        label="Nom (*)"
                        :rules="[() => !!$store.state.usersEditedItem.NOM || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.usersEditedItem.PRENOM"
                        label="Prenom (*)"
                        :rules="[() => !!$store.state.usersEditedItem.PRENOM || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="9"
                    md="8"
                >
                    <v-text-field
                        v-model="$store.state.usersEditedItem.EMAIL"
                        label="Email (*)"
                        :rules="[() => !!$store.state.usersEditedItem.EMAIL || 'E-mail obligatoire',
                            !$store.state.usersEditedItem.EMAIL || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test($store.state.usersEditedItem.EMAIL) || 'E-mail invalide'
                        ]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="2"
                    md="2"
                >
                    <v-checkbox
                        v-model="$store.state.usersEditedItem.ADMIN"
                        label="Admin"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireUsers",
		data: function () {
			return {
            }
        }
    }
</script>
